module.exports = __webpack_public_path__ + "fonts/Lato-Italic.4eb103b4.woff2";